import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LoggerService } from 'app/core/logger/logger.service';

/**
 * Reemplaza al ErrorHandler por defecto de Angular, que hace `console.error`
 * del error tal cual: un `HttpErrorResponse` no atrapado (un `.subscribe()`
 * sin callback de error) se imprimía entero, con la URL y su query string.
 */
@Injectable()
export class LoggingErrorHandler implements ErrorHandler {
    private readonly _logger = inject(LoggerService);

    handleError(error: unknown): void {
        // Una promesa rechazada llega envuelta por zone.js en un Error cuyo
        // mensaje ya trae el valor serializado (con la URL, si era un error
        // HTTP): se registra el valor original.
        const rejection = (error as { rejection?: unknown } | null)?.rejection;
        this._logger.error('Unhandled error:', rejection ?? error);
    }
}
